export default __webpack_public_path__ + "static/media/tiger.19de5cff.png";